import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './Views/Home.vue'
import Profile from './Views/Profile.vue'
import Settings from './Views/Settings'
import Ranking from './Views/Ranking'
import Trophies from './Views/Trophies'
import Collection from './Views/Collection'
import Masque from './Views/MasqueScanned.vue'
import Scan from './Views/Scan.vue'
import Login from './Views/Login.vue'
import Gallery from './Views/Gallery.vue'
import LandingPage from './Views/LandingPage.vue'
import LaunchScreen from './Views/LaunchScreen.vue'
import ScanList from './Views/ScanList.vue'
import PageNotFound from "./Views/PageNotFound";
import ResetPassword from "./Views/ResetPassword";
import Dashboard from "./Views/Dashboard";
import Games from "./Views/Games";

Vue.use(VueRouter)

export default new VueRouter({
    routes: [
        {
            path: '/camera',
            name: 'camera',
            component: Home
        },
        {
            path: '/scan',
            name: 'scan',
            component: Scan
        },
        {
            path: '/masque/:qrcode_uid',
            name: 'masque',
            component: Masque
        },
        {
            path: '/profile',
            name: 'profile',
            component: Profile
        },
        {
            path: '/login/:type',
            name: 'login',
            component: Login,
            beforeEnter: (to, from, next) => {
                if (localStorage.getItem('user')) {
                    next('/camera')
                } else {
                    next()
                }
            }

        },
        {
            path: '/rp/:token',
            name: 'rp',
            component: ResetPassword
        },
        {
            path: '/gallerie',
            name: 'gallerie',
            component: Gallery
        }, {
            path: '/connexion',
            name: 'LandingPage',
            component: LandingPage,
            beforeEnter: (to, from, next) => {
                if (localStorage.getItem('user')) {
                    next('/camera')
                } else {
                    next()
                }
            }
        },
        {
            path: '/',
            name: 'LaunchScreen',
            component: LaunchScreen
        },
        {
            path: '/settings',
            name: 'settings',
            component: Settings
        },
        {
            path: '/ranking',
            name: 'ranking',
            component: Ranking
        },
        {
            path: '/trophies',
            name: 'trophies',
            component: Trophies
        },
        {
            path: '/collection',
            name: 'collection',
            component: Collection
        },
        {
            path: '/scanlist',
            name: 'scanlist',
            component: ScanList
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard
        }, {
            path: '/games',
            name: 'games',
            component: Games
        },
        {
            path: '/logout',
            name: 'logout',
            beforeEnter(to, from, next) {
                localStorage.clear()
                next('/')
            },
        },
        {
            path: "*",
            component: PageNotFound
        }
    ]
})
